import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import VueJsonToCsv from 'vue-json-to-csv' 
import VModal from 'vue-js-modal'
import Vuelidate from 'vuelidate'

Vue.use(VueRouter)
Vue.use(VueJsonToCsv)
Vue.use(Vuelidate)
Vue.use(VModal)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/signin',
    name: 'Signin',
    component: () => import('@/views/Signin.vue'),
  },
  {
    path: '/management',
    name: 'ApplicationManagement',
    component: () => import('@/views/ApplicationManagement.vue'),
  },
  {
    path: '/masterdata',
    name: 'MasterData',
    component: () => import('@/views/Bankit/MasterData/MasterData.vue'),
  },
  {
    path: '/applicationuserdata',
    name: 'ApplicationUserData',
    component: () => import('@/views/Bankit/ApplicationUserData/ApplicationUserData.vue'),
  },
  {
    path: '/applicationUserDataDetails',
    name: 'ApplicationUserDataDetails',
    component: () => import('@/views/Bankit/ApplicationUserData/ApplicationUserDataDetails.vue'),
  },
  {
    path: '/paymentMethod',
    name: 'PaymentMethod',
    component: () => import('@/views/Bankit/PaymentMethods/PaymentMethod.vue'),
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: () => import('@/views/Bankit/Transactions/Transactions.vue'),
  },
  {
    path: '/transactionDetails',
    name: 'TransactionDetails',
    component: () => import('@/views/Bankit/Transactions/TransactionDetails.vue'),
  },
  {
    path: '/merchant',
    name: 'Merchant',
    component: () => import('@/views/Bankit/Merchants/Merchants.vue'),
  },
  {
    path: '/merchantDetails',
    name: 'MerchantDetails',
    component: () => import('@/views/Bankit/Merchants/MerchantDetails.vue'),
  },
  {
    path: '/merchantTerminal',
    name: 'MerchantTerminal',
    component: () => import('@/views/Bankit/MerchantTerminal/MerchantTerminal.vue'),
  },
  {
    path: '/merchantTerminalDetails',
    name: 'MerchantTerminalDetails',
    component: () => import('@/views/Bankit/MerchantTerminal/MerchantTerminalDetails.vue'),
  },
  {
    path: '/otasukeForecast',
    name: 'OtasukeForecast',
    component: () => import('@/views/Bankit/OtasukeForecast/OtasukeForecast.vue'),
  },
  {
    path: '/otasukeForecastDetails',
    name: 'OtasukeForecastDetails',
    component: () => import('@/views/Bankit/OtasukeForecast/OtasukeForecastDetails.vue'),
  },
  {
    path: '/otasukeRepayment',
    name: 'OtasukeRepayment',
    component: () => import('@/views/Bankit/OtasukeRepayment/OtasukeRepayment.vue'),
  },
  {
    path: '/otasukeRepaymentDetails',
    name: 'OtasukeRepaymentDetails',
    component: () => import('@/views/Bankit/OtasukeRepayment/OtasukeRepaymentDetails.vue'),
  },
  {
    path: '/paymentTransactions',
    name: 'PaymentTransactions',
    component: () => import('@/views/Bankit/PaymentTransactions/PaymentTransactions.vue'),
  },
  {
    path: '/paymentTransactionsDetails',
    name: 'PaymentTransactionsDetails',
    component: () => import('@/views/Bankit/PaymentTransactions/PaymentTransactionsDetails.vue'),
  },
  {
    path: '/userRegistrationSummary',
    name: 'UserRegistrationSummary',
    component: () => import('@/views/Bankit/UserRegistrationSummary/UserRegistrationSummary.vue'),
  },
  {
    path: '/userRegistrationSummaryDetails',
    name: 'UserRegistrationSummaryDetails',
    component: () => import('@/views/Bankit/UserRegistrationSummary/UserRegistrationSummaryDetails.vue'),
  },
  {
    path: '/userSummaryList',
    name: 'UserSummaryList',
    component: () => import('@/views/Bankit/UserRegistrationSummary/UserSummaryList.vue'),
  },
  {
    path: '/transactionRecordSummary',
    name: 'TransactionRecordSummary',
    component: () => import('@/views/Bankit/TransactionRecordSummary/TransactionRecordSummary.vue'),
  },
  {
    path: '/transactionRecordSummaryDetails',
    name: 'TransactionRecordSummaryDetails',
    component: () => import('@/views/Bankit/TransactionRecordSummary/TransactionRecordSummaryDetails.vue'),
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('@/views/Jobs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/jobs/register',
    name: 'RegisterJob',
    component: () => import('@/views/RegisterJob.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/jobs/:id',
    name: 'Job',
    component: () => import('@/views/Job.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/outputData',
    name: 'OutputData',
    component: () => import('@/views/OutputData.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/contractDetails',
    name: 'ContractDetails',
    component: () => import('@/views/Bankit/MasterData/ContractDetails.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settlementDetails',
    name: 'SettlementDetails',
    component: () => import('@/views/Bankit/MasterData/SettlementDetails.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/points',
    name: 'Points',
    component: () => import('@/views/Points.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('@/views/Notifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () => import('@/views/Partners.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/partnerDetails',
    name: 'PartnerDetails',
    component: () => import('@/views/PartnerDetails.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/createPartner',
    name: 'CreatePartner',
    component: () => import('@/views/CreatePartner.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/editPartner',
    name: 'EditPartner',
    component: () => import('@/views/EditPartner.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '*',
    redirect: '404',
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
       return savedPosition
    } else {
       return { x: 0, y: 0 }
    }
  }
})

var verifiedAccountProfile = false

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next()
    return;
  }
  // ログイン必須
  var requiresAuthFunc = function(user) {
    if (!user) {
      verifiedAccountProfile = false;
      next({ name: 'Signin', query: { redirect: to.fullPath } })
      return
    }
    else {
      if (verifiedAccountProfile) {
        // User作成済みの確認が取れている場合はデータ量が無駄なので再確認しない
        next()
        return
      }
      firebase.firestore().collection('users').doc(user.uid).get().then((doc) => {
        // 会員が存在する
        if (doc.exists) {
          let data = doc.data();
          if(data.is_admin!==undefined && data.is_admin) {
            verifiedAccountProfile = true;
            next();
          }
          else {
            //next({ name: 'Signin'});
            firebase.auth().signOut();
          }
        }
        else {
          next({ name: 'Signin'})
        }
      });
    }
  };
/*   const currentUser = firebase.auth().currentUser
  if (currentUser) {
    requiresAuthFunc(currentUser)
    return
  } */

  var authFlag=true;
  var unsub=firebase.auth().onAuthStateChanged(user => {
    if(authFlag){
      authFlag=false;
      requiresAuthFunc(user)
      unsub();
    }
  })
  return
})

export default router
